import { Controller } from "@hotwired/stimulus"
import loadYmaps from "../../src/shared/helpers/load_ymaps"

export default class extends Controller {
  static values = { lat: Number, lng: Number, name: String }

  connect() {
    loadYmaps(() => {
      ymaps.ready(() => {
        const lat = this.latValue || 0
        const lng = this.lngValue || 0
        const name = this.nameValue || ""
        const map = new ymaps.Map(this.element, {
          center: [lat, lng],
          zoom: 12,
          controls: ['zoomControl', 'fullscreenControl']
        })
        const placemark = new ymaps.Placemark(
          [lat, lng],
          { balloonContent: name },
          { preset: 'islands#redDotIcon' }
        )
        map.geoObjects.add(placemark)
        placemark.balloon.open()
      })
    })
  }
}
